import { useQuery } from '@tanstack/react-query'

import type { MediaAsset, Page } from '../../../shared/api'
import { api } from '../../../shared/api'
import type { MediaQuery } from '../media.api.types'

export function useMedia(q: MediaQuery, enabled = true) {
  return useQuery({
    queryKey: ['media', q],
    queryFn: () => api<Page<MediaAsset>>('/media/assets', { query: { ...q } }),
    enabled,
    placeholderData: (prev) => prev,
    // Poll while anything is still processing so tiles turn READY by themselves.
    refetchInterval: (query) =>
      query.state.data?.items.some(
        (a) => a.status === 'PROCESSING' || a.status === 'UPLOADING',
      )
        ? 2_000
        : false,
  })
}
